import { Form, Input } from "antd";
import React from "react";

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
    required: '${label} is required!',
    types: {
        email: '${label} is not a valid email!',
        number: '${label} is not a valid number!',
    },
    number: {
        range: '${label} must be between ${min} and ${max}',
    },
};
/* eslint-enable no-template-curly-in-string */

export const StyledInputSHB = () => {
    return (
        <>
            <div>
                <Form
                    layout="vertical"
                    autoComplete="off"
                    className="mtp-form"
                    validateMessages={validateMessages}
                >
                    <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                        <Input className="mtp-form-control" placeholder="Insert Your Placeholder Text" />
                    </Form.Item>

                    <Form.Item name="email" label="Email" rules={[{ type: 'email' }]}>
                        <Input className="mtp-form-control" />
                    </Form.Item>

                    <Form.Item name="website" label="Website">
                        <Input className="mtp-form-control" />
                    </Form.Item>

                    <Form.Item name="shb-textarea-one" label="Resizable Textarea">
                        <Input.TextArea className="mtp-form-control" />
                    </Form.Item>

                    <Form.Item name="shb-textarea-two" label="NON-Resizable Textarea">
                        <Input.TextArea className="mtp-form-control resize-none" />
                    </Form.Item>
                </Form>
            </div>
        </>
    )
}